<template>
  <section
    class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-customer" class="modal absolute block w-5/6 bg-white shadow-md rounded-lg" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Daftar Order</h5>
      </div>
      <div id="modal-body" class="p-5 dark:bg-dark-900">
        <SearchBox v-model="search" placeholder="Cari Kode Order" class-add="w-full" />
        <TableComponent>
          <TableHead>
            <TableRow>
              <TableHeadCell>Action</TableHeadCell>
              <TableHeadCell>Kode</TableHeadCell>
              <TableHeadCell>Nama Pelanggan</TableHeadCell>
              <TableHeadCell>Metode Pembayaran</TableHeadCell>
              <TableHeadCell>Bayar</TableHeadCell>
              <TableHeadCell>Status</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow v-for="salesOrder in allSalesOrders" :key="salesOrder.id">
              <TableCell>
                <button @click="submit(salesOrder)"
                  class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                  <CheckCircleIcon class="h-4 w-4 group-hover:text-green-700" />
                </button>
              </TableCell>
              <TableCell>
                {{ salesOrder.code }}
              </TableCell>
              <TableCell>
                {{ salesOrder.customer_name }}
              </TableCell>
              <TableCell>
                {{ formatPaymentMethodeName(salesOrder.payment_method_id) }}
              </TableCell>
              <TableCell>
                {{ formatPrice(salesOrder.payment_amount) }}
              </TableCell>
              <TableCell>
                {{ salesOrder.status }}
              </TableCell>
            </TableRow>
          </TableBody>
        </TableComponent>
        <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
      </div>
      <div class="modal-footer p-5 dark:bg-dark-900">
        <div class="flex justify-center">
          <SubmitButton button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white"
            @click="closeModal" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import SubmitButton from '../form/SubmitButton.vue';
  import PaginationButtons from '../PaginationButtons.vue';
  import {
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
  } from "@/components/table";
  import { CheckCircleIcon } from '@heroicons/vue/24/outline';
  import SearchBox from '@/views/pages/new-transaction/SearchBox.vue';
import { paymentMethode } from '@/helpers/constanta';

  export default {
    name: 'ModalSalesOrder',
    components: {
      SubmitButton,
      TableComponent,
      TableHead,
      TableRow,
      TableHeadCell,
      TableBody,
      TableCell,
      PaginationButtons,
      CheckCircleIcon,
      SearchBox
    },
    data() {
      return {
        showModal: true,
        currentPage: 1,
        totalPages: 1,
        search: '',
        searchTimeout: null,
      };
    },
    props: {
      params: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapGetters('sales_orders', ['allSalesOrders']),
      ...mapGetters('tables', ['allTables']),
      ...mapGetters('payment_methods', ['allPaymentMethods']),
    },
    created() {
      this.$store.dispatch('sales_orders/fetchSalesOrders', this.params);
      this.$store.dispatch('tables/fetchTables');
      this.$store.dispatch('payment_methods/fetchPaymentMethods');
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(newVal) {
          this.fetchSalesOrders({ page: newVal });
        },
      },
      search: {
        immediate: true,
        handler(newVal) {
          if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
          }

          this.searchTimeout = setTimeout(() => {
            if (newVal) {
              this.fetchSalesOrders({ code: newVal });
            } else {
              this.fetchSalesOrders();
            }
          }, 1500);
        },
      }
    },
    methods: {
      ...mapActions('sales_orders', ['fetchSalesOrders']),
      formatPaymentMethodeName(paymentMethodId) {
        const paymentMethod = this.allPaymentMethods.find(paymentMethod => paymentMethod.id === paymentMethodId);
        return paymentMethode?.[paymentMethod?.name?.toUpperCase()] || paymentMethod?.name || '-';
      },
      async fetchSalesOrders(params = { page: 1, limit: 10 }) {
        if (!params.page) params.page = this.currentPage;
        if (!params.limit) params.limit = 10;

        try {
          const { pagination } = await this.$store.dispatch('sales_orders/fetchSalesOrders', params);
          if (pagination) {
            this.totalPages = pagination.totalPages;
          }
        } catch (error) {
          console.log(error);
        }
      },
      closeModal() {
        this.showModal = false;
        this.$emit('closeModal');
        setTimeout(() => {
          this.$emit('closeModal');
        }, 300);
      },
      formatPrice(price) {
        return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(price);
      },
      findTable(id) {
        return this.allTables.find(t => t.id == id);
      },
      findPaymentMethod(id) {
        return this.allPaymentMethods.find(t => t.id == id);
      },
      submit(salesOrder) {
        this.$confirm.require({
          group: 'headless',
          header: 'Apakah anda yakin ingin mengubah order?',
          message: 'Silahkan konfirmasi sebelum diproses.',
          acceptLabel: 'Ya',
          rejectLabel: 'Tidak',
          accept: () => {
            this.$emit('submit', salesOrder);
            this.closeModal();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil mengubah order', life: 3000 });
          },
          reject: () => {
            this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal mengubah order', life: 3000 });
          }
        });
      },
    },
  }
</script>